export interface IdentificationRequestPayload {
	jwt: string;
	id: string;
	nonce: string;
	type: IdentificationType;
}

export enum IdentificationType {
	RESPONSE,
	REQUEST
}
